import React from "react";
import { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SimpleReactValidator from 'simple-react-validator';

import {getPickSlip, getProductDetails} from '../../actions/orderFulfillment';
import {saveOrderAcknowledge} from '../../actions/orderFulfillment';
import noImage from '../../assets/images/noProductImg_420x420.jpg'


import 'react-tabs/style/react-tabs.scss';


class Ackpick extends Component {
    
    constructor() {
        super()
        this.state = {
            details : [],
            checked : false,
            sku_qty : [],
            
            pickslip_details : [] ,
            product_details : []
        }
        this.validator = new SimpleReactValidator();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this)

    }
   
    componentDidMount() {
        let queries = queryString.parse(this.props.location.search)
    this.setState({
        details : queries})
        

        this.props.getProductDetails(this.props.connection_id,queries.fo_no)
        this.setState({
            pds:this.props.product_details
        })

       
       this.props.getPickSlip(this.props.connection_id,queries.fo_no)


    }

    handleChange(event) {
      
        
        this.setState({ [event.target.id]: event.target.value });

    }
    handleCheck(event) {
       if(event.target.checked){
           this.setState({
               checked : true
           })
         
           
       }
       else {
        this.setState({
            checked : false
        })
        
       


       }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        // if (this.validator.allValid()) {
        const { connection_id } = this.props
        const pds = this.props.product_details;
        const de = document.getElementById('display-error');
        var product = [];
        var products = [];
        var status ='';

        if( this.state.checked == false){
            status = 'R'
            if(pds && pds.length > 0)
        {
        pds.map((pd,index)=>{
            var sk = 'sku_code_'+index;
            var act_qty = document.getElementById(sk).value;
           

           if(act_qty > pd.sku_qty || act_qty.value <= 0 || act_qty.length == 0 )
           {
            de.style.color='red'
               de.innerHTML='Add proper Acknowledge Qty' 
              
                products =[]
                

        
    } else {
        de.innerHTML='' 
        product = {'sku_code' : pd.sku_code,'qty' : document.getElementById(sk).value }
                products.push(product)
    }
        })
    }

        }else {
            status = 'A';
            if(pds && pds.length > 0)
            {
                pds.map((pd,index)=>{
                    product = {'sku_code' : pd.sku_code,'qty' : pd.sku_qty }
                    products.push(product)
                })
               
    
            }
        }
       
    let options = {
        connection_id,
        fo_no : this.state.details.fo_no,
        fo_status:status,
        products:products
    }
    if(products.length!=0) {
     this.props.saveOrderAcknowledge(options)
    this.props.history.goBack()
    } 
        // }
        // else {
        //     this.validator.showMessages();
        //     this.forceUpdate();
        // }
       
        
    }


    handleBack = () => {
        this.props.history.push('/ack')
    }
    
    render() {
       const  pickslip_details = this.props.pickslip_details
       const product_details = this.props.product_details
       if(this.state.details.fo_date )
       {
       var dateTime = this.state.details.fo_date
       var date = dateTime.substr(0,10)
       } else {
           var date =''
       }
       

          
        return (
            
            
            <Tabs className='tab-content'>
                <div className='ack-tab-list'>
                    <TabList>
                        <Tab><span className="nav-link" >
                            <span className="tab_title">Acknowledge</span>
                        </span>
                            <div className="material-border"></div></Tab>
                            {pickslip_details && pickslip_details.length > 0 ?  
                        <Tab> <span className="nav-link" >
                            <span className="tab_title">Pick Slip</span>
                        </span>
                            <div className="material-border"></div></Tab>
                            : 
                            <Tab disabled={true}> <span className="nav-link" >
                            <span className="tab_title">Pick Slip</span>
                        </span>
                            <div className="material-border"></div></Tab>}
                    </TabList>
                </div>
                <TabPanel> <React.Fragment>
                    <div className='container   ack-main' style={{  paddingBottom: 100 }}>
                       {/*  <div style={{ padding: 15 }}>
                            <h5 style={{ textAlignLast: 'center' }}>Order Acknowledge</h5>
                        </div> */}
                        <div style={{ paddingBottom: 8 }}>
                            <div className='row'>
                                <div className='col'><b>FO No</b>
                                </div><div className='col-1'>:</div><div className='col'>
                                    {this.state.details.fo_no}
                                    </div>
                            </div>
                            <div className='row'>
                                <div className='col'><b>FO Date</b>

                                </div><div className='col-1'>:</div><div className='col'>
                                {date}</div>
                            </div>

                        </div>

                        <div className='row'>
                     
                            <div className='col-9'><label>Accept All Items for Fulfillment</label></div>
                            <div className='col'>
                            <input type="checkbox"  onChange={(e)=>this.handleCheck(e)} defaultChecked={this.state.checked}/>
                               </div>
                        </div>
                        <br/>
                        <form onSubmit={(e) => this.handleSubmit(e)}>

                        {product_details && product_details.length > 0 ? 
                        <React.Fragment>
                        { product_details.map((product_detail,index)=>{
var sku_code1 = "sku_code_"
var sk = sku_code1.concat(index)

                            return(
                                <React.Fragment>

                        <div className='row' style={{ paddingBottom: 15 }}>
                            <div className='col'>
                                <div>
                                {product_detail.brand}
                               
                           </div>
                                <div>
                                    {product_detail.category}
                           </div>
                                <div>
                                {product_detail.sku_code}
                                

                           </div>
                           <div>{product_detail.color}/{product_detail.size}</div>


                            </div>
                            <div className='col'>
                                <div>
                                <img src={product_detail.image !== null && product_detail.image !== "" ? product_detail.image : noImage} style={{ width: '65%' }} alt=''/>

                                    {/* <img src={product_detail.image} style={{ width: '65%' }} /> */}
                                </div>
                               
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col'>
                                FO Qty
                            </div>
                            <div className='col-1'>:</div>
                            <div className='col'>
                                {product_detail.sku_qty}
                           </div> 
                        </div>
                        <div className='row'>
                            <div className='col' style={{paddingBottom:8}}>
                                <b>ACK Qty</b>
                            </div>
                            <div className='col-1' style={{paddingBottom:8}}>:</div>
                           {/*  <div className='col' className='qty'>
                            
                          
                            <input type="text" className="form-control" id={sk} name={index}
                                             defaultValue={this.state.sku_qty} onChange={(e) => this.handleChange(e)} />                          </div>

                           <div className='col'  className='qty1' style={{display:'none'}}>

                            <input type="text" className="form-control" name="" value= {product_detail.sku_qty} 
                         readOnly/>
                          
                           
                           

                           </div> */}
                           {this.state.details.fo_status === 'NOT ACKNOWLEDGED' ? 
                           
                           <div className='col'>
                           <input type="text" className="form-control" id={sk} name={index}   defaultValue={this.state.sku_qty} onChange={(e) => this.handleChange(e)} disabled={this.state.checked} />                          

                           </div> :
                           <div className='col'>
                                <input type="text" className="form-control" id={sk} name={index}   value={product_detail.sku_qty} onChange={(e) => this.handleChange(e)} disabled={true} />
                           </div>
                        }
                        </div>
                        {/* {this.validator.message('qty',this.state.sku_qty , 'required')} */}

                        <br/>
                         <br/>
                        </React.Fragment>
                            )
                        })}
                       
</React.Fragment> : 
                        <div className='row'>
                            <div className='col'>
                                <button className='btn btn-solid' onClick={() => this.handleBack()}>BACK</button>
                            </div>
                        </div> }
                        
                        {this.state.details.fo_status === 'NOT ACKNOWLEDGED' ? 
                    <div className='container' >
                        <div id='display-error' className="row"  style={window.innerWidth > 1080 ? {position:"fixed",padding:10,backgroundColor: "#FFFFFF" ,bottom:50}:{position:"fixed" ,padding:10,backgroundColor: "#FFFFFF",bottom:50}} ></div>
                           <div className='row bootom-bar' style={window.innerWidth > 1080 ? {position:"fixed",padding:10,width:'26vw',backgroundColor: "#FFFFFF"}:{position:"fixed" ,right:35,padding:10,width:'90vw',backgroundColor: "#FFFFFF"}}>
                            
                            <div className='col'>
                                <button className='btn btn-solid' style={{padding:'8px 20px'}} onClick={() => this.handleBack()}>BACK</button>
                            </div>
                             
                            <div className='col'>
                                <button type='submit' className='btn btn-solid' style={{ float: "right",padding:'8px 20px' }}>SAVE</button>

                            </div>
                            
                            

                        </div>
                        </div>

:   <div className='row bootom-bar' style={{position:"fixed",padding:10,width:'45vw',backgroundColor: "#FFFFFF"}}>
<div className='col' style={{textAlignLast:'center'}}>
    <button className='btn btn-solid' onClick={() => this.handleBack()} style={{padding:'8px 20px'}}>BACK</button>
</div></div> }
                     
                        </form>

                    </div>
                    
                </React.Fragment>
                </TabPanel>
                <TabPanel><React.Fragment>
                    <div className='container ack-main' style={{  paddingBottom: 100 }}>
                       {/*  <div style={{ padding: 15 }}>
                            <h5 style={{ textAlignLast: 'center' }}>Order Acknowledge</h5>
                        </div> */}
                        {pickslip_details && pickslip_details.length >0 ? 
                        <React.Fragment>
                         {  pickslip_details.map((pickslip,index)=>{
                      let dateTime = pickslip.fo_date;
                      let date = dateTime.substr(0,10); 
                      return ( <React.Fragment id={index}>
                        <div style={{ paddingBottom: 8 }}>
                            <div className='row'>
                                <div className='col'><b>FO No</b>
                                </div><div className='col-1'>:</div><div className='col'>
                                    {pickslip.fo_no}
                                    </div>
                            </div>
                            <div className='row'>
                                <div className='col'><b>FO Date</b>

                                </div><div className='col-1'>:</div><div className='col'>
                                    {date}</div>
                            </div>

                        </div>
                        <div style={{ paddingBottom: 10 }}>
                            <div className='row'>
                                <div className='col'>Picker Name</div>
                                <div className='col-1'>:</div>
                                <div className='col'>{pickslip.picker_name}</div>
                            </div>

                            <div className='row'>
                                <div className='col'>Picker Slip No</div>
                                <div className='col-1'>:</div>
                                <div className='col'>{pickslip.pickslip_no}</div>
                            </div>
                        </div>
                        {pickslip.product_details.map((pd,index) => {
                            return(
                                <React.Fragment id={index}>
                        <div className='row' >
                            <div className='col'>
                                <div>
                                    {pd.brand}
                           </div>
                                <div>
                                    {pd.category}
                           </div>
                                <div>
                                    {pd.sku_code}
                           </div>
                           <div>{pd.color}/{pd.size}</div>

                            </div>
                            <div className='col'>
                                <div>
                                    <img src={pd.image !== "" && pd.image !== null ? pd.image : noImage} style={{ width: '65%' }} />
                                </div>
                            </div>
                            
                        </div>
                        <div className='row' style={{paddingTop:10}}>
                            <div className='col'>
                                FO Qty
                            </div>
                            <div className='col-1'>:</div>
                            <div className='col'>
                                {pd.pick_qty}&nbsp;Nos
                           </div>
                        </div>

                        </React.Fragment>
                            )
                        })}
                        
                         {/*  <hr />
                        <div className='row w_100' >
                            <div className='col w_50'>
                                <div>
                                    Puma
                           </div>
                                <div>
                                    T-Shirt
                           </div>
                                <div>
                                    AXR0001
                           </div>
                                <div>
                                    10
                           </div>
                            </div>
                            <div className='col w_50'>
                                <div>
                                    <img src={require('./tshirt.jpg')} style={{ width: '65%' }} />
                                </div>
                                <div style={{ padding: 'inherit' }}>Blue/M</div>
                            </div>
                        </div>
                        */}
                         <br/>
                         <hr />
                         <br/>
                         </React.Fragment> )
                    }) } 
                    </React.Fragment> : '' }


                         
                        
                    </div>
                    <div className='row bootom-bar' style={{position:"fixed",backgroundColor: "#FFFFFF",padding:10,width:'106vw'}}>
                            <div className='col' style={{    textAlignLast: 'center'}}>
                                <button className='btn btn-solid' onClick={() => this.handleBack()}>Back</button>
                            </div>
                        </div>
                </React.Fragment>
                </TabPanel>
            </Tabs>

        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id,
    pickslip_details : state.orderFulfillment.slip_details,
    product_details : state.orderFulfillment.product_details



});


const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getPickSlip,saveOrderAcknowledge,getProductDetails },
        dispatch
    );


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Ackpick));
